export default {
  formateDate (date) {
    date =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      '-' +
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
      ' ' +
      date.getHours() +
      ':' +
      date.getMinutes() +
      ':' +
      date.getSeconds()
    return date
  },
  formateDateTime (date) {
    let dateArray = date.splite('-')
    let yyyy = dateArray[0]
    let MM = dateArray[1].length < 2 ? '0' + dateArray[1] : dateArray[1]
    let DD = dateArray[2].length < 2 ? '0' + dateArray[2] : dateArray[2]
  },
  dataURItoBlob (dataURI) {
    let bytes =
      dataURI.split(',')[0].indexOf('base64') >= 0
        ? atob(dataURI.split(',')[1])
        : unescape(dataURI.split(',')[1])
    let mime = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]
    let max = bytes.length
    let ia = new Uint8Array(max)
    for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i)
    return new Blob([ia], { type: mime })
  },
  dateToUnixtimestamp (dateObj, time) {
    // 时间戳
    // return dateObj.getTime() / 1000
    return ((dateObj.setHours(0, 0, 0, 0)) + time * 3600 * 24 * 1000) / 1000
  },
  isCellPhone () {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      return true
    } else {
      return false
    }
  },
  resizeBase64: async function (base64Str, MAX_WIDTH = 200, MAX_HEIGHT = 200) {
    // Max size for thumbnail
    function getImageDimensions (file) {
      return new Promise(function (resolve, reject) {
        let i = new Image()
        i.src = file
        i.onload = function () {
          return resolve({ width: i.width, height: i.height })
        }
      })
    }
    let img = new Image()
    let { width, height } = await getImageDimensions(base64Str)
    img.src = base64Str
    let canvas = document.createElement('canvas')
    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width
        width = MAX_WIDTH
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height
        height = MAX_HEIGHT
      }
    }
    canvas.width = width
    canvas.height = height
    let ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, width, height)
    return canvas.toDataURL()
  },
  blobToDataURI (blob, callback) {
    var reader = new FileReader()
    reader.onload = function (e) {
      callback(e.target.result)
    }
    reader.readAsDataURL(blob)
  },
  urlToBase64 (url) {
    console.log(url)
    function loadXHR (url) {
      return new Promise((resolve, reject) => {
        try {
          let xhr = new XMLHttpRequest()
          xhr.open('GET', url)
          xhr.setRequestHeader('cache-control', 'no-cache')
          xhr.responseType = 'blob'
          xhr.onerror = () => { reject(new Error('Network error.')) }
          xhr.onload = function () {
            if (xhr.status === 200) { resolve(xhr.response) } else { reject(new Error('Loading error:' + xhr.statusText)) }
          }
          xhr.send()
        } catch (err) { reject(err.message) }
      })
    }
    return new Promise(async (resolve, reject) => {
      let blob = await loadXHR(url)
      let reader = new FileReader()
      reader.onload = function (e) {
        return resolve(e.target.result)
      }
      reader.readAsDataURL(blob)
    })
  }
}
